var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-badge',{attrs:{"variant":"light-secondary"}},[_vm._v("To be continued...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }